export default __webpack_public_path__ + "static/media/star_2.6933a830.svg";